import React, { useEffect, useState } from "react";
import { useAuthGlobal } from "../../../../../../contexts/auth-context/auth-context";
import { FilterModel } from "../../../../../../domain/models/enum";
import { PackageProps } from "../../../../../../domain/models/package.model";
import { SolicitationResponseModel } from "../../../../../../domain/models/solicitation.model";
import { StackModel } from "../../../../../../domain/models/stacks";
import SolicitationListPage from "../../../../../../presentation/pages/admin/solicitation/list";
import { settings } from "../../../../../configs/settings";
import { makeRemotePackage } from "../../../../usecases/package/remote-package-factory";
import { makeRemoteSolicitation } from "../../../../usecases/solicitation/remote-solicitation-factory";
import { makeRemoteStack } from "../../../../usecases/stack/remote-stack-factory";

const generateFilter = (values: any): string =>
  Object.keys(values)
    .filter((el) => !!values[el])
    .map((el) => {
      if (el === "status") {
        return `${el}=${values[el]}`;
      }
      return el;
    })
    .join(",");

function MakeSolicitationList(): JSX.Element {
  const { profile, user } = useAuthGlobal();
  const [list, setList] = useState<SolicitationResponseModel>();
  const [params, setParams] = useState<FilterModel>({});
  const [loading, setLoading] = useState<boolean>();
  const [stackList, setStackList] = useState<StackModel[]>();
  const [packageList, setPackageList] = useState<PackageProps[]>();
  const [reload, setReload] = useState<boolean>(false);

  const loadData = async (): Promise<void> => {
    try {
      setLoading(true);
      const stackResponse = await makeRemoteStack().loadAll();
      setStackList(stackResponse);
      const packageResponse =
        (await makeRemotePackage().loadAll()) as unknown as PackageProps[];
      setPackageList(packageResponse);
      const data = await makeRemoteSolicitation().load({
        size: settings.perPage,
        page: params?.page,
        query: params?.query,
        filters: generateFilter({
          status: "PENDING",
        }),
      });
      setList(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, profile, user, reload]);

  const handleReload = (): void => {
    setReload((prev) => !prev);
  };

  return (
    <SolicitationListPage
      // params={params}
      list={list}
      setParams={setParams}
      loading={loading}
      packageList={packageList}
      stackList={stackList}
      handleReload={handleReload}
    />
  );
}

export default MakeSolicitationList;
